import { Card, Heading, Stack } from '@autoplan/web-ui'
import { type HelpContent, useLocale } from '@autoplan/web-sanity'

type ContactInfoCardProps = {
  contact: NonNullable<HelpContent['contact']>
}

export const ContactInfoCard = ({ contact }: ContactInfoCardProps) => {
  const { t } = useLocale()

  return (
    <Card className="ap:p-2xl" background="white">
      <Stack spacing="xl">
        <Heading size="lg">{t('home.contact.title')}</Heading>
        {contact.phone && (
          <Stack spacing="2xs">
            <span className="ap:text-sm ap:font-semibold">{t('common.labels.phone')}</span>
            <a href={`tel:${contact.phone}`} className="ap:w-fit ap:text-content-link ap:hover:underline">
              {contact.phone}
            </a>
          </Stack>
        )}
        {contact.email && (
          <Stack spacing="2xs">
            <span className="ap:text-sm ap:font-semibold">{t('common.labels.email')}</span>
            <a href={`mailto:${contact.email}`} className="ap:w-fit ap:text-content-link ap:hover:underline">
              {contact.email}
            </a>
          </Stack>
        )}
        {contact.address && (
          <Stack spacing="2xs">
            <span className="ap:text-sm ap:font-semibold">{t('home.contact.address')}</span>
            <span className="ap:text-content-secondary">{contact.address}</span>
          </Stack>
        )}
      </Stack>
    </Card>
  )
}
